

































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import InvestigateApi from '@/api/investigate'
import LawyerApi from '@/api/lawyer'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './lawyer-list-config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'

@Component({
	name: 'lawyerList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private taskDetailPwd(action: any) {
		return `/setting/lawyerDetail/${action.id}`
	}

	public created() {
		this.$store.dispatch('setting/initAreas')
	}

	private exportList() {
		this.exportingList = true
		LawyerApi.exportList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	public getList() {
		return LawyerApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree')
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYY-MM-DD')
		delete form.rangeTime

		return form
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择律师')
			return false
		}
		return true
	}

	private enable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认启用吗 ?',
				onOk: () => {
					const form = {
						visitorId: selected.id,
					}
					return LawyerApi.activeLawyer(form).then((res: any) => {
						this.$message.success('启用成功')
						this.getList()
					})
				},
			})
		}
	}

	private disable() {
		if (this.checkSelected()) {
			const selected = this.selected[0]
			this.$confirm({
				title: '提示',
				content: '确认停用吗 ?',
				onOk: () => {
					const form = {
						visitorId: selected.id,
					}
					return LawyerApi.inactiveLawyer(form).then((res: any) => {
						this.$message.success('停用成功')
						this.getList()
					})
				},
			})
		}
	}
}
